import {
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CHECKOUT,
  PAGE_TYPE_LOGIN,
  TENANT_FR,
} from 'shared/consts'
import { REDCARE_INFO_MODAL } from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import store from 'shared/store'

const blacklistedPages = [
  PAGE_TYPE_ACCOUNT,
  PAGE_TYPE_CART,
  PAGE_TYPE_CHECKOUT,
  PAGE_TYPE_LOGIN,
]
const REDCARE_INFO_MODAL_ID = 'RedcareInfoModal'

const triggerRedcareInfoModal = () => {
  setTimeout(function () {
    window.location.hash = REDCARE_INFO_MODAL_ID
    window.sessionStorage.setItem(REDCARE_INFO_MODAL_ID, 'true')
    window._uxa = window._uxa || []
    window._uxa.push([
      'trackPageview',
      `${window.location.pathname}${window.location.hash.replace('#', '/__')}`,
    ])
  }, 3000)
}

const isPageBlacklisted = (page: string) => blacklistedPages.includes(page)

export default () => {
  const isRedcareInfoModalShown = window.sessionStorage.getItem(
    REDCARE_INFO_MODAL_ID
  )
  const publicRuntimeConfig = store.getState()?.publicRuntimeConfig
  const { tenant } = publicRuntimeConfig?.publicConfig || {}
  const { experiments = [], pageType = '' } =
    publicRuntimeConfig?.pageProperties || {}

  if (
    isPageBlacklisted(pageType) ||
    tenant !== TENANT_FR ||
    isRedcareInfoModalShown
  ) {
    return
  }

  const redcareModalExperiment = getExperiment(REDCARE_INFO_MODAL, experiments)

  if (redcareModalExperiment.isEnabled) {
    triggerRedcareInfoModal()
  }
}
